import { FeatureKey } from './types';
import { formatStudioModuleLabel } from './studio-modules';

/**
 * Composition links one Studio module to another (e.g. Circle setup → Courses).
 * Composition must never hard-block the parent module — only the linked action.
 */
export type StudioCompositionState = 'available' | 'unavailable';

export function isStudioModuleEnabled(
  features: Readonly<Partial<Record<FeatureKey, boolean>>>,
  key: FeatureKey,
): boolean {
  return features[key] === true;
}

export function resolveStudioCompositionState(
  features: Readonly<Partial<Record<FeatureKey, boolean>>>,
  targetModule: FeatureKey,
): StudioCompositionState {
  return isStudioModuleEnabled(features, targetModule) ? 'available' : 'unavailable';
}

export function formatStudioCompositionUnavailableMessage(moduleKey: FeatureKey): string {
  const label = formatStudioModuleLabel(moduleKey);
  return `${label} is not available. Please contact support if you need access.`;
}
